/* =========================================================
   Affiche ÉQUITATION « Le cavalier » — les galops, la frise, l'écurie.
   API : SNEqCavalier.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, lieu, cavalier, cheval,
              mode 'galops'   → g1..g7 (année d'obtention, vide = non passé), mention
              mode 'histoire' → f1..f8 (« 2018|Première leçon »)
              mode 'ecurie'   → boxes (nombre, 4 à 12), monBox (numéro), cheval, mention
              + s1..s3 (« valeur|libellé ») pour le bandeau }
     opts : { palette }

   Les galops 1 à 7 sont LE repère de progression en France : c'est la première
   chose qu'un jeune cavalier annonce, bien avant ses résultats en concours.

   Auto-suffisant (aucun fetch, aucune image) → re-render serveur direct.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    craie:    { label:'Craie',    bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', sable:'#E4D5B7', deep:'#D8C7A4' },
    sable:    { label:'Sable',    bg:'#EDE3D2', ink:'#2C3A2E', muted:'#8A8676', accent:'#C4622D', line:'#DDD0B9', card:'#F7F1E6', sable:'#DCCFB6', deep:'#CDBE9E' },
    carriere: { label:'Carrière', bg:'#12362B', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#164536', sable:'#C9B489', deep:'#0B271F' },
    nuit:     { label:'Nuit',     bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', sable:'#C9B489', deep:'#082444' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  function stats(p, data, y) {
    const it = [];
    for (let i = 1; i <= 3; i++) {
      const raw = String(data['s' + i] || '').trim(); if (!raw) continue;
      const [v, l] = raw.split('|').map(s => (s || '').trim());
      if (v) it.push([v, l || '']);
    }
    if (!it.length) return '';
    const x0 = 54, w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 38, 0.56, 0, 17), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const mode = String(data.mode || 'galops').toLowerCase();
    const cx = PW / 2;

    const DEF = { galops: 'MES GALOPS', histoire: 'NOTRE HISTOIRE', ecurie: 'MON ÉCURIE' };
    const titre = up(data.titre) || DEF[mode] || 'MES GALOPS';
    const ts = fit(titre, 690, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || up(data.club) || 'ÉQUITATION';
    const sous = [up(data.cavalier), up(data.lieu)].filter(Boolean).join(' · ');

    let corps = '', barreY = 990;

    if (mode === 'galops') {
      /* Un galop est « obtenu » dès qu'une année est saisie : le client n'a
         pas à cocher une case en plus. */
      const an = [];
      for (let i = 1; i <= 7; i++) an.push(String(data['g' + i] || '').trim());
      const obtenus = an.filter(Boolean).length;
      for (let i = 0; i < 7; i++) {
        const col = i % 4, lig = Math.floor(i / 4);
        /* la seconde rangée n'a que trois pastilles : on la centre */
        const nRang = lig === 0 ? 4 : 3;
        const larg = nRang * 152, x0 = cx - larg / 2 + 76;
        const ccx = x0 + (col % 4) * 152 - (lig === 0 ? 0 : 0);
        const ccy = 430 + lig * 200;
        const fait = !!an[i];
        corps += `<circle cx="${ccx.toFixed(1)}" cy="${ccy}" r="58" fill="${fait ? p.accent : 'none'}" stroke="${fait ? p.accent : p.line}" stroke-width="3"/>`
          + T(ccx, ccy + 16, 46, fait ? p.bg : p.line, String(i + 1), { f:'Oswald', w:700 })
          + T(ccx, ccy + 88, 13, fait ? p.ink : p.muted, fait ? esc(an[i]) : '—', { w:600, ls:2 });
      }
      if (data.mention) corps += T(cx, 850, fit(up(data.mention), 660, 16, 0.66, 4, 11), p.accent, esc(up(data.mention)), { w:700, ls:4 });
      else if (obtenus) corps += T(cx, 850, 16, p.accent, 'GALOP ' + obtenus + ' OBTENU', { w:700, ls:4 });

    } else if (mode === 'histoire') {
      const et = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['f' + i] || '').trim(); if (!raw) continue;
        const [d, e] = raw.split('|').map(s => (s || '').trim());
        if (d && e) et.push([d, e]);
      }
      if (et.length) {
        const x = 178, zone = 620, pas = Math.min(104, zone / et.length), y0 = 336 + (zone - pas*et.length) / 2;
        corps = `<line x1="${x}" y1="${y0.toFixed(1)}" x2="${x}" y2="${(y0 + (et.length-1)*pas).toFixed(1)}" stroke="${p.line}" stroke-width="2.5"/>`;
        et.forEach((e, i) => {
          const y = y0 + i * pas, dernier = i === et.length - 1;
          corps += `<circle cx="${x}" cy="${y.toFixed(1)}" r="${dernier ? 14 : 8}" fill="${dernier ? p.accent : p.ink}"/>`
            + (dernier ? `<circle cx="${x}" cy="${y.toFixed(1)}" r="5" fill="${p.bg}"/>` : '')
            + T(x - 34, y + 8, 26, p.muted, esc(e[0]), { f:'Oswald', w:700, a:'end' })
            + T(x + 36, y + 9, fit(e[1], 560, 26, 0.60, 0, 15), p.ink, esc(e[1]), { f:'Oswald', w:700, a:'start' });
        });
      } else corps = T(cx, 600, 20, p.muted, 'FORMAT : ANNÉE, BARRE VERTICALE, ÉVÉNEMENT', { w:600, ls:2 });

    } else { /* ecurie */
      const n = Math.max(4, Math.min(12, Math.round(num(data.boxes) || 8)));
      const mien = Math.round(num(data.monBox) || 0);
      const cols = n > 8 ? 4 : 4, w = 124, h = 132, gx = 152;
      const rangs = Math.ceil(n / cols);
      for (let i = 0; i < n; i++) {
        const col = i % cols, lig = Math.floor(i / cols);
        const nRang = Math.min(cols, n - lig * cols);
        const x = cx - (nRang * gx) / 2 + col * gx + (gx - w) / 2;
        const y = 420 + lig * 168;
        const est = (i + 1) === mien;
        corps += `<rect x="${x.toFixed(1)}" y="${y}" width="${w}" height="${h}" rx="8" fill="${est ? p.accent : p.card}"/>`
          + `<rect x="${(x + 18).toFixed(1)}" y="${y + 22}" width="${w - 36}" height="46" rx="5" fill="${p.deep}" opacity="${est ? 0.35 : 0.55}"/>`;
        for (let k = 1; k < 4; k++) corps += `<line x1="${(x + 18 + (w-36)*k/4).toFixed(1)}" y1="${y+22}" x2="${(x + 18 + (w-36)*k/4).toFixed(1)}" y2="${y+68}" stroke="${est ? p.accent : p.card}" stroke-width="2.5"/>`;
        corps += T(x + w/2, y + 106, est ? 17 : 15, est ? p.bg : p.muted, est ? esc(up(data.cheval) || 'MON CHEVAL') : '—', { f:'Oswald', w:700, ls:1 });
      }
      const yl = 420 + rangs * 168 + 20;
      if (data.mention) corps += T(cx, yl, fit(up(data.mention), 660, 15, 0.66, 4, 11), p.accent, esc(up(data.mention)), { w:700, ls:4 });
      barreY = 960;
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${stats(p, data, barreY)}
</svg>`;
  }

  window.SNEqCavalier = { render, PALETTES };
})();
